// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disable-scrollbars[data-v-67befe53]{scrollbar-width:none;-ms-overflow-style:none}.disable-scrollbars[data-v-67befe53]::-webkit-scrollbar{display:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
